const hosts = new Set([
  'fashionunited.in',
  'fashionunited.com.br',
  'fashionunited.jp',
  'fashionunited.ie',
  'fashionunited.com',
  'fashionunited.it',
  'fashionunited.uk',
  'fashionunited.cl',
  'fashionunited.co',
  'fashionunited.com.ar',
  'fashionunited.com.pe',
  'fashionunited.es',
  'fashionunited.mx',
  'fashionunited.ru',
  'fashionunited.ch',
  'fashionunited.at',
  'fashionunited.cn',
  'fashionunited.com.tr',
  'fashionunited.cz',
  'fashionunited.dk',
  'fashionunited.fi',
  'fashionunited.hk',
  'fashionunited.hu',
  'fashionunited.lu',
  'fashionunited.no',
  'fashionunited.pl',
  'fashionunited.pt',
  'fashionunited.se',
  'fashionunited.fr',
  'fashionunited.be',
  'fashionunited.be/fr',
  'fashionunited.nl',
  'fashionunited.de',
  'au.fashionunited.com',
]);

const hasJobLanding = (host) => hosts.has(host);

export default hasJobLanding;
